/* unplugin-vue-components disabled */import script from "./alarmHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmHistory.vue?vue&type=script&setup=true&lang=js"

import "./alarmHistory.vue?vue&type=style&index=0&id=94ce3bae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94ce3bae"]])

export default __exports__